import { Controller } from '@hotwired/stimulus'
import { renderStreamMessage } from '@hotwired/turbo'

export default class extends Controller {
  static values = {
    assessmentId: Number,
    outcome: { type: Boolean, default: false },
    jurisdictionSlug: String,
    isIrr: { type: Boolean, default: false },
    testerId: String,
    backUrl: String
  }

  connect() {
    this.handlePopState = this.handlePopState.bind(this)
    this.pushState = this.pushState.bind(this)

    // Only intercept popstate for assessment-related pages
    if (this.assessmentIdValue || this.outcomeValue) {
      window.addEventListener('popstate', this.handlePopState)
    }
    window.addEventListener('turbo:submit-start', this.pushState)
  }

  disconnect() {
    if (this.assessmentIdValue || this.outcomeValue) {
      window.removeEventListener('popstate', this.handlePopState)
    }
    window.removeEventListener('turbo:submit-start', this.pushState)
  }

  pushState() {
    history.pushState({}, '', '')
  }

  triggerPopState() {
    if (this.hasBackUrlValue && this.backUrlValue) {
      window.location.href = this.backUrlValue
    } else {
      history.back()
    }
  }

  handlePopState() {
    const slug = this.jurisdictionSlugValue
    if (this.outcomeValue) {
      // If this is an IRR test, redirect to tester dashboard
      if (this.isIrrValue && this.testerIdValue) {
        window.location.replace(`/reliability-testers/${this.testerIdValue}`)
      } else if (slug) {
        window.location.replace(`/${slug}/concerns`)
      } else {
        history.back()
      }
      return
    }

    const assessmentId = this.assessmentIdValue


    fetch(`/assessments/${assessmentId}/previous_question`, {
      headers: { Accept: 'text/vnd.turbo-stream.html' }
    })
      .then(async (response) => {
        if (response.ok) {
          const html = await response.text()
          renderStreamMessage(html)
          window.scrollTo({ top: 0 })
        }
      })
      .catch(() => {
        // Fetch failed - redirect based on test type
        if (this.isIrrValue && this.testerIdValue) {
          window.location.assign(`/reliability-testers/${this.testerIdValue}`)
        } else if (id) {
          window.location.assign(`/jurisdictions/${id}/concerns`)
        }
      })
    }
  }
